import { displayShortcut } from "../lib/controls";

/**
 * Tiny optional shortcut chip. Hidden unless keyboard badges are on.
 * The pressable CommandBar strip is gone (DIALER.md: no CommandBar).
 */
export function ShortcutBadge({ value }: { value: string }) {
  if (!value) return null;
  return (
    <span className="rounded bg-black/35 px-1 py-px font-mono text-[10px] leading-none text-mute">
      {displayShortcut(value)}
    </span>
  );
}
